"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chronologicalNumberStatus = exports.translateStatus = exports.allReservationStatus = void 0;
exports.allReservationStatus = [
    'booked',
    'started',
    'in-activity',
    'done',
    'finalize',
    'gift-voucher',
    'cancelled',
];
const statusLabels = {
    cancelled: 'Annulée',
    'gift-voucher': 'Bon Cadeau / Avoirs',
    booked: 'Réservation',
    started: 'En location',
    'in-activity': 'Activité en cours',
    done: 'Terminée',
    finalize: 'Finalisée'
};
const translateStatus = (status) => {
    return statusLabels[status] || 'Inconnu';
};
exports.translateStatus = translateStatus;
const chronologicalNumberStatus = (status) => {
    var _a;
    const order = [
        { status: "no-changes", order: 0 },
        { status: "wait-to-deleted", order: 0 },
        { status: "gift-voucher", order: 0 },
        { status: "cancelled", order: 0 },
        { status: "booked", order: 1 },
        { status: "started", order: 2 },
        { status: "in-activity", order: 3 },
        { status: "done", order: 4 },
        { status: "finalize", order: 5 }
    ];
    return ((_a = order.find(s => s.status === status)) === null || _a === void 0 ? void 0 : _a.order) || 0;
};
exports.chronologicalNumberStatus = chronologicalNumberStatus;
//# sourceMappingURL=reservationStatus.js.map